import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchBookingEventTemplateByIdArgs,
  FetchBookingEventTemplatesArgs,
} from '../api/types/bookingEventTemplates.types';

import {
  fetchBookingEventTemplateById,
  fetchBookingEventTemplates,
} from '../api/bookingEventTemplates.api';

export const bookingEventTemplatesQueryKeys = createQueryKeys(
  'bookingEventTemplates',
  {
    fetchBookingEventTemplateById: ({
      bookingEventTemplateId,
      organizationId,
    }: FetchBookingEventTemplateByIdArgs) => ({
      queryFn: () =>
        fetchBookingEventTemplateById({
          bookingEventTemplateId,
          organizationId,
        }),
      queryKey: [organizationId, bookingEventTemplateId],
    }),
    fetchBookingEventTemplates: ({
      organizationId,
      search,
    }: FetchBookingEventTemplatesArgs) => ({
      queryFn: () => fetchBookingEventTemplates({ organizationId, search }),
      queryKey: [organizationId, search],
    }),
  },
);
